import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import axios from "axios";

const API_URL = process.env.REACT_APP_BASE_URL;
const headers = {
  "Content-Type": "application/json",
};

export interface Department {
  id?: number;
  packageName: string;
  packageData: string;
  districtCode: string;
  districtName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}

export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

//*// changed fields
// export interface SupplierPayload {
//   supplier_name: string;
//   onboarding_date: string;
//   email: string;
//   phone_number: string;
//   contact_person_name: string;
//   contact_person_email: string;
//   contact_person_phone_no: string;
//   KYC_approved: boolean;
// }
export interface SupplierPayload {
  supplier_name: string;
  supplier_code: string;
  email: string;
  phone_number: string;
  address: string,
  city: string,
  state: string,
  country: string,
  pincode: string,
  contact_person_name: string,
  contact_person_phone_no: string,
  GSTIN: string,
}



export const fetchSuppliers = createAsyncThunk(
  "supplier/fetchSuppliers",
  async ({
    page,
    pageSize,
    search,
    sort,
    order,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: ColumnFiltersState;
  }) => {
    try {
      const params: Record<string, any> = {
        page,
        page_size: pageSize,
      };

      if (search) params.search = search;

      if (sort) {
        params.ordering = order === "desc" ? `-${sort}` : sort;
      }

      if (filters && Array.isArray(filters)) {
        filters.forEach(filter => {
          const { id, value } = filter
          if (!id || value === undefined || value === '') return
          if ((id === 'updated_at' || id === 'created_at') && typeof value === 'object') {
            const { from_date, to_date } = value as { from_date?: string; to_date?: string }
            if (from_date) params["from_date"] = from_date
            if (to_date) params["to_date"] = to_date
          } else {
            params[id] = value
          }
        })
      }

      const response: any = await Axios.get(`/supplier/supplier/list/`, { params });

      const responseData = response.data;

      return {
        data: responseData.results || [],
        rowCount: typeof responseData.total_records === 'number' ? responseData.total_records : 0
      };
    } catch (error: any) {
      console.error(
        "supplier error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch supplier");
    }
  }
);

export const fetchById = createAsyncThunk(
  "department/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/department/${id}/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch department by ID"
      );
    }
  }
);

export const updateSuppliers = createAsyncThunk(
  "suppliers/updateSuppliers",
  async (packageData: any) => {
    const response: any = await Axios.put(
      `/department/${packageData.id}/`,
      packageData
    );
    return response;
  }
);



// export const updateStatusInSuppliers = createAsyncThunk(
//   "suppliers/updateStatusInSuppliers",
//   async ({ supplier_id }: { supplier_id: string }, { rejectWithValue }) => {
//     try {
//       const response = await Axios.put(
//         `/supplier/suppliers/update_status/${supplier_id}/`
//       );
//       return response.data;
//     } catch (err: any) {
//       return rejectWithValue(
//         err.response?.data || err.message || "Failed to update supplier status"
//       );
//     }
//   }
// );

export const updateStatusInSuppliers = createAsyncThunk(
  "suppliers/updateStatusInSuppliers",
  async (
    { supplier_id, is_active }: { supplier_id: string; is_active: boolean },
    { rejectWithValue }
  ) => {
    try {
      const response = await Axios.put(
        `/supplier/suppliers/update_status/${supplier_id}/`,
        { is_active }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to update supplier status"
      );
    }
  }
);



export const addSuppliers = createAsyncThunk(
  "suppliers/addDepartment",
  async (addSuppliers: any) => {
    const response = await Axios.post(`${API_URL}/department/`);
    return response.data;
  }
);

export const createSuppliers = createAsyncThunk(
  "suppliers/createSuppliers",
  async (
    {
      supplier,
      supplier_name,
      head_of_department,
    }: {
      supplier: string;
      supplier_name: string;
      head_of_department: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const userData = localStorage.getItem("authUser");
      const token = userData ? JSON.parse(userData).access : "";
      const response = await Axios.post(
        "/department/create/",
        { supplier, supplier_name, head_of_department },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to create department"
      );
    }
  }
);

export const fechCreateSupplier = createAsyncThunk(
  "suppliers/createSupplier",
  async (payload: SupplierPayload, { rejectWithValue }) => {
    try {
      const userData = localStorage.getItem("authUser");
      const token = userData ? JSON.parse(userData).access : "";
      const response = await Axios.post(
        "/supplier/suppliers/create/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to create supplier"
      );
    }
  }
);

export const fechItemKYC = createAsyncThunk(
  "suppliers/fechItemKYC",
  async (
    { supplierId, formData }: { supplierId: string; formData: FormData },
    { rejectWithValue }
  ) => {
    try {
      const userData = localStorage.getItem("authUser");
      const token = userData ? JSON.parse(userData).access : "";
      const response = await Axios.post(
        `/supplier/suppliers/complex_create/${supplierId}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          },
        }
      );
      console.log('fechItemKYC Response:', response.data);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to create supplier"
      );
    }
  }
);

export const fetchSupplierItemsAndKycItemName = createAsyncThunk(
  "suppliers/fetchSupplierItems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        "/supplier/item_list/",
        { params: { column: "item_name" } }
      );
      // Returns: [{ item_name: "A Item" }, ...]
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch item list");
    }
  }
);


export const deleteSuppliers = createAsyncThunk(
  "suppliers/delete",
  async (id: number, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/department/${id}/`, { headers });
      return id;
    } catch (err: any) {
      console.error("Delete error:", err);
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const deleteSupplierItem = createAsyncThunk(
  "suppliers/deleteSupplierItem",
  async (
    { supplier_id, item_id }: { supplier_id: string; item_id: string },
    thunkAPI
  ) => {
    try {
      const token = localStorage.getItem("token"); // or get it from Redux/auth
      const response = await Axios.delete(
        `/supplier/supplier_item/delete_Item/${supplier_id}/${item_id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Delete failed"
      );
    }
  }
);



export const fetchAllDropdownsSuppliers = createAsyncThunk(
  "suppliers/fetchAllDropdownsSuppliers",
  async (column: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/supplier/droupdown_list/`,
        { params: { columns: column } }
      );

      const dropdownData = response.data?.data || response.data || [];

      console.log("Dropdown API response:", dropdownData);

      return { column, data: dropdownData };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch dropdown');
    }
  }
);


// export const exportCSVSuppliers = createAsyncThunk(
//   "suppliers/exportCSVSuppliers",
//   async (_, { rejectWithValue }) => {
//     try {
//       const token = localStorage.getItem("authToken");
//       const headers = {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json",
//         Accept: "*/*",
//       };
//       const response = await Axios.get("/supplier/supplier/list/?export=csv", {
//         headers,
//         responseType: "blob",
//       });
//       return {
//         blob: response.data,
//         filename:
//           response.headers["content-disposition"]
//             ?.split("filename=")[1]
//             ?.replace(/"/g, "") || "Suppliers.csv",
//       };
//     } catch (err: any) {
//       console.error("Export CSV error:", err);
//       return rejectWithValue(err.message || "Failed to export CSV");
//     }
//   }
// );

export const fetchSupplierBydropdown = createAsyncThunk(
  "suppliers/fetchSupplierBydropdown",
  async (_,{ rejectWithValue }) => {
    try {
      const response = await Axios.get(`master/supplier/dropdown`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch supplier dropdown");
    }
  }
);

export const exportCSVSuppliers = createAsyncThunk(
  "suppliers/exportCSVSuppliers",
  async (
    {
      filters,
    }: {
      filters?: ColumnFiltersState;
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };

      const params: Record<string, any> = {
        export: "csv",
      };

      // Only apply column filters (not global search)
      if (filters && Array.isArray(filters)) {
        filters.forEach((filter) => {
          const { id, value } = filter;
          if (!id || value === undefined || value === "") return;

          if ((id === "updated_at" || id === "created_at") && typeof value === "object") {
            const { from_date, to_date } = value as { from_date?: string; to_date?: string };
            if (from_date) params["from_date"] = from_date;
            if (to_date) params["to_date"] = to_date;
          } else {
            params[id] = value;
          }
        });
      }

      const response = await Axios.get("/supplier/supplier/list/", {
        headers,
        params,
        responseType: "blob",
      });

      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]?.split("filename=")[1]?.replace(/"/g, "") ||
          "Suppliers.csv",
      };
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);


export const fetchSupplierBySupplierId = createAsyncThunk(
  "suppliers/fetchSupplierBySupplierId",
  async (supplier_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/supplier/supplier/SupplierRetrieve/${supplier_id}/`
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to fetch supplier by supplier_id"
      );
    }
  }
);

export const fetchSupplierBySupplierIdKYCDetails = createAsyncThunk(
  "suppliers/fetchSupplierBySupplierIdKYCDetails",
  async (supplier_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/supplier/supplier/getdata/${supplier_id}/`
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to fetch supplier kyc details"
      );
    }
  }
);


export const fetchUpdateSupplierBySupplierId = createAsyncThunk(
  "suppliers/fetchUpdateSupplierBySupplierId",
  async (
    { supplier_id, data }: { supplier_id: string; data: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await Axios.put(
        `/supplier/supplier/SupplierUpdate/${supplier_id}/`,
        data
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to update supplier"
      );
    }
  }
);


export const fetchSupplierByItemAndKYCId = createAsyncThunk(
  "suppliers/fetchSupplierByItemAndKYCId",
  async (supplier_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/supplier/supplier/getdata/${supplier_id}/`
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to fetch supplier by supplier_id"
      );
    }
  }
);



export const fetchUpdateSupplierByItemAndKYCId = createAsyncThunk(
  "suppliers/fetchUpdateSupplierByItemAndKYCId",
  async (
    { supplier_id, data }: { supplier_id: string; data: any },
    { rejectWithValue }
  ) => {
    try {
      const response = await Axios.put(
        `/supplier/suppliers/update/${supplier_id}/`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          },
        }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to update supplier"
      );
    }
  }
);

export const fetchGetAprovePrice = createAsyncThunk(
  "suppliers/fetchGetAprovePrice",
  async (supplier_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/supplier/supplier_item_units/created/${supplier_id}/`
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to fetch approved price data"
      );
    }
  }
);

export const fetchUpdateAprovePrice = createAsyncThunk(
  "suppliers/fetchUpdateAprovePrice",
  async (
    { supplier_id, data }: { supplier_id: string; data: any },
    { rejectWithValue }
  ) => {
    try {
      const userData = localStorage.getItem("authUser");
      const token = userData ? JSON.parse(userData).access : "";
      const response = await Axios.put(
        `/supplier/supplier_item_units/update/${supplier_id}/`,
        data
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to update supplier"
      );
    }
  }
);

export const fetchSupplierItemUnits = createAsyncThunk(
  "suppliers/fetchSupplierItemUnits",
  async (supplier_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/supplier/supplier_item_units/update/${supplier_id}/`
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to fetch supplier item units"
      );
    }
  }
);


export const fetchSupplierByBranchDetailsId = createAsyncThunk(
  "suppliers/fetchSupplierByBranchDetailsId",
  async (supplier_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `/supplier/supplier/branch_details/${supplier_id}/`
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to fetch supplier by supplier_id"
      );
    }
  }
);

export const fetchDeleteBranchById = createAsyncThunk(
  "suppliers/fetchDeleteBranchById",
  async (
    {
      supplierId,
      basic_supplier_id,
      index,
    }: {
      supplierId: string;
      basic_supplier_id: string;
      index: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const formData = new FormData();
      formData.append(`basic_details[${index}][basic_supplier_id]`, basic_supplier_id);

      const response = await Axios.delete(
        `/supplier/supplier/branch_delete/${supplierId}/`,
        {
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message || "Failed to delete branch");
    }
  }
);


export const fetchUpdateSupplierByBranchDetailsId = createAsyncThunk(
  "suppliers/fetchUpdateSupplierByBranchDetailsId",
  async ({ supplier_id, formData }: any, { rejectWithValue }) => {
    try {
      const userData = localStorage.getItem("authUser");
      const token = userData ? JSON.parse(userData).access : "";
      console.log('formData', formData)
      const response = await Axios.put(
        `/supplier/supplier/branch_update/${supplier_id}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to update supplier branch details"
      );
    }
  }
);
export const fetchSupplierUpdateAprovePrice = createAsyncThunk(
  "suppliers/fetchSupplierUpdateAprovePrice",
  async (
    {
      supplier_id,
      data,
    }: {
      supplier_id: string;
      data: any
    },
    { rejectWithValue }
  ) => {
    try {
      const userData = localStorage.getItem("authUser");
      const token = userData ? JSON.parse(userData).access : "";

      const response = await Axios.put(
        `/supplier/supplier_item_units/update/${supplier_id}/`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to update supplier item units"
      );
    }
  }
);



export const fechCreateBrabchDeatils = createAsyncThunk(
  "suppliers/fechCreateBrabchDeatils",
  async (
    { supplierId, formData }: { supplierId: string; formData: FormData },
    { rejectWithValue }
  ) => {
    try {
      const response = await Axios.post(
        `/supplier/supplier/branch_create/${supplierId}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );


      console.log('fechItemKYC Response:', response.data);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to create supplier"
      );
    }
  }
);

export const fetchDelteAprovePrice = createAsyncThunk(
  "suppliers/fetchDelteAprovePrice",
  async (itemUnit_id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.delete(
        `/supplier/supplier_item_units/Delete/${itemUnit_id}/`
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || err.message || "Failed to delete aproved price data"
      );
    }
  }
);
